import {
    SET_OUT_OF_SERVICE, 
    RESET_REDUX, 
    SET_USER,
    SET_SELECTED_ROOM,
    SET_CURRENT_ROOM,
    SET_GUEST,
    CLEAN_ROOM_SELECTION,
    CLEAN_CURRENT_ROOM_SELECTION,
    CLEAN_GUEST_SELECTION,
    SET_CUSTOMER_INFO,
    SET_STAFF_INFO,
    SET_PAYMENT_INFO,
    CLEAN_PAYMENT_INFO,
    SET_PICKED_DATE
} from './action-types'

export const setOutOfService = (outOfService) => ({
    type: SET_OUT_OF_SERVICE,
    data: outOfService
})

export const resetRedux = () => ({
    type: RESET_REDUX,
    data: null
})

export const saveUser = (user) => ({
    type: SET_USER,
    data: user
})

export const setSelectedRoom = (selectedRoom) => ({
    type: SET_SELECTED_ROOM,
    data: selectedRoom
})

export const setCurrentRoom = (currentRoom) => ({
    type: SET_CURRENT_ROOM,
    data: currentRoom
})

export const setGuest = (tenantId, type) => ({
    type: SET_GUEST,
    data: {tenantId, type}
})

export const cleanRoomSelection = () => ({
    type: CLEAN_ROOM_SELECTION,
    data: null
})

export const cleanCurrentRoomSelection = () => ({
    type: CLEAN_CURRENT_ROOM_SELECTION,
    data: null
})

export const cleanGuestSelection = () => ({
    type: CLEAN_GUEST_SELECTION,
    data: null
})

export const setCustomerInfo = (customerInfo) => ({
    type: SET_CUSTOMER_INFO,
    data: customerInfo
})

export const setStaffInfo = (staffInfo) => ({
    type: SET_STAFF_INFO,
    data: staffInfo
})

export const setPaymentInfo = (paymentInfo) => ({
    type: SET_PAYMENT_INFO,
    data: paymentInfo
})

export const cleanPaymentInfo = () => ({
    type: CLEAN_PAYMENT_INFO,
    data: null
})

export const setPickedDate = (pickedDate) => ({
    type: SET_PICKED_DATE,
    data: pickedDate
})